import React, { useContext, useMemo, useState } from 'react'
import CommonScreen from 'admin/component/CommonScreen'
import {
  strCol,
  numCol,
  dateTimeCol,
  intCol,
} from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import * as ScreenPermissions from 'core/EventActions'
import * as api from '../../../api/pgads'
import {
  modifiedDateCol,
  modifierCol,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { Button, DatePicker, InputNumber, Select } from 'antd'
import { DatePickerContext } from 'context'
import {
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  hasAccesPermits,
  monthsMap,
  severity,
} from 'core'
import { connect } from 'react-redux'
import { usePmgrApi } from 'report-dashboard/hooks'
import moment from 'moment'

const headers = [
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  unitIdHeader,
  strCol({ ident: 'procType', display: 'Proc Type', isFiltered: true }),
  dateTimeCol({
    ident: 'errorDate',
    display: 'Error Date',
    isFiltered: true,
    width: 200,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'errorCode',
    display: 'Error Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'errorMsg',
    display: 'Error Message',
    isFiltered: true,
    alignment: 'left',
    width: 400,
    ellipsis: true,
  }),
  numCol({
    ident: 'severity',
    display: 'Severity',
    isFiltered: true,
    ...toSelectionColProps(severity),
  }),
  modifierCol,
  modifiedDateCol,
]
const title = 'Process All'

const ProcessAll = ({ unitNameMap, envConfig, actionPermits }) => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const [month, setMonth] = useState(moment().month() + 1 + '')
  const [year, setYear] = useState(moment().year())
  const [saveProcessAllTask, saving] = usePmgrApi(api.saveProcessAll)
  const [validateProcessAllTask, validating] = usePmgrApi(
    api.validateProcessAll
  )
  const ValidateAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.TALEN_VALIDATE_PROCESS_ALL,
          ScreenPermissions.CHANGE_PERMISSIONS,
        ],
        matchAny: false,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
        }}
      />
    )
  }

  const extraCriteriaAfterButton = ({ onRetrieve }) => {
    return (
      <div style={{ border: '1px solid', padding: '5px' }}>
        <label>Month :</label>
        <Select
          style={{ width: '120px', marginLeft: '5px' }}
          value={month}
          onChange={val => setMonth(val)}
        >
          {Object.keys(monthsMap).map(m => (
            <Select.Option key={m} value={m}>
              {monthsMap[m]}
            </Select.Option>
          ))}
        </Select>
        <label style={{ marginLeft: '10px' }}>Year :</label>
        <InputNumber
          value={year}
          onChange={value => setYear(value)}
          style={{ width: '100px', marginLeft: '5px' }}
        />
        <Button
          loading={saving || validating}
          onClick={_ =>
            saveProcessAllTask({ year, month }).fork(console.log, jcErrors => {
              console.log({ jcErrors })
              onRetrieve()
            })
          }
          style={{ backgroundColor: '#e6f7ff', marginLeft: '10px' }}
        >
          Save All
        </Button>
        <Button
          loading={saving || validating}
          onClick={_ =>
            validateProcessAllTask({ year, month }).fork(
              console.log,
              jcErrors => {
                console.log({ jcErrors })
                onRetrieve()
              }
            )
          }
          style={{ backgroundColor: '#e6f7ff', marginLeft: '10px' }}
        >
          Validate All
        </Button>
      </div>
    )
  }

  const headerWithFormatter = useMemo(
    _ =>
      headers.map(header =>
        header.ident === 'unitId'
          ? {
              ...header,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header
      ),
    [unitNameMap]
  )

  return (
    <CommonScreen
      title={title}
      isAdminScreen={false}
      header={headerWithFormatter}
      retrieveTask={api.getProcessAll}
      screenCriteria={screenCriteria}
      withCriteria={() => ({
        fromDate: selectedDateRangePicker[0],
        toDate: selectedDateRangePicker[1],
      })}
      extraCriteriaAfterButton={
        ValidateAccess ? extraCriteriaAfterButton : null
      }
      autoRetrieve
      sortOptions={headerWithFormatter}
      widthOffset={50}
      autoFixColByKey={false}
      headerRowHeight={60}
      allowInsert={false}
      withoutModify
    />
  )
}

const mapStateToProps = state => ({
  unitNameMap: getUnitNameMap(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(ProcessAll)
